/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_EnableInputs */



/**
* | output |
* | --- |
* | "Enable" |
*
* @param {Live_Caption_EnableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_enable = /** @type {((inputs?: Live_Caption_EnableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_EnableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktivieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abilitare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Давать возможность")
	if (locale === "es") return /** @type {LocalizedString} */ ("Permitir")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("使能够")
	if (locale === "ja") return /** @type {LocalizedString} */ ("有効にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सक्षम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Habilitar")
	return /** @type {LocalizedString} */ ("Enable")
});